// src/components/AboutUs.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const VALUES = [
  {
    title: 'العميل أولاً',
    text: 'نضع احتياجات عملائنا على رأس أولوياتنا، ونسعى دائمًا لتقديم أفضل تجربة ممكنة، من لحظة التصفح إلى ما بعد البيع.',
    tone: 'yolk'
  },
  {
    title: 'الجودة والابتكار',
    text: 'نلتزم بتقديم منتجات عالية الجودة ونسعى باستمرار للابتكار في خدماتنا وتقنياتنا لتقديم حلول تسوق فريدة.',
    tone: 'ink'
  },
  {
    title: 'الشفافية والثقة',
    text: 'نبني علاقاتنا مع العملاء على الثقة والشفافية التامة، من معلومات المنتج حتى سياسات الإرجاع.',
    tone: 'yolk'
  },
  {
    title: 'المسؤولية الاجتماعية',
    text: 'نتحمل مسؤوليتنا تجاه مجتمعنا ونعمل على دعم المبادرات المحلية وخلق بيئة تجارية مستدامة.',
    tone: 'ink'
  }
];

const CheckIcon = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm-1-9a1 1 0 112 0v2a1 1 0 11-2 0v-2z" clipRule="evenodd" />
  </svg>
);

const AboutUs = () => {
  return (
    <div className="relative container mx-auto p-8 md:p-16" dir="rtl">

      {/* زر العودة إلى الرئيسية */}
      <div className="absolute top-8 left-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-bold
            bg-[#F2B705] text-[#1B1B1F] hover:bg-[#1B1B1F] hover:text-white
            transition-colors duration-200 shadow-sm
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F2B705] focus-visible:ring-offset-2"
        >
          العودة إلى الرئيسية
          <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </Link>
      </div>

      {/* قسم العنوان والمقدمة */}
      <div className="text-center mb-20 pt-16 md:pt-0">
        <span
          className="inline-block px-4 py-1 rounded-full bg-[#F2B705]/15 text-[#1B1B1F] text-sm font-bold -rotate-2 mb-4"
          style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
        >
          #من_نحن
        </span>
        <h1
          className="text-4xl md:text-6xl font-extrabold text-[#1B1B1F] mb-4"
          style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
        >
          من نحن
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
          في ميمي ستور، نحن لا نبيع المنتجات فقط؛ بل نبني تجربة تسوق استثنائية. نؤمن بأن كل عملية شراء هي قصة جديدة، وكل عميل هو جزء من عائلتنا.
        </p>
      </div>

      {/* قسم قصتنا */}
      <div className="bg-white p-8 rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.08)] mb-16">
        <h2
          className="text-3xl font-bold text-[#1B1B1F] mb-6 border-b-2 border-[#F2B705] pb-3 inline-block"
          style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
        >
          قصتنا
        </h2>
        <div className="text-lg text-gray-700 leading-relaxed space-y-6">
          <p>
            تأسست ميمي ستور عام 2025 برؤية واضحة: أن نصبح المنصة الرائدة للتجارة الإلكترونية في المنطقة. بدأنا رحلتنا بتقديم تشكيلة محدودة من المنتجات، ولكن بفضل ثقة عملائنا، توسعنا لنقدم اليوم كل ما يحتاجه عملاؤنا من منتجات إلكترونية، أزياء، مستلزمات منزلية، جمال، وغيرها الكثير.
          </p>
          <p>
            نحن نؤمن بأن التسوق عبر الإنترنت يجب أن يكون ممتعاً وسهلاً وموثوقاً به. لذلك، نعمل باستمرار على تحسين منصتنا لتكون سهلة الاستخدام، آمنة، وتوفر خيارات دفع وشحن متعددة تناسب الجميع. فريقنا مكرس لضمان رضاكم، من لحظة تصفحكم لمنتجاتنا حتى وصول طلباتكم إلى عتبة منزلكم.
          </p>
        </div>
      </div>

      {/* قسم رؤيتنا ورسالتنا */}
      <div className="grid md:grid-cols-2 gap-8 mb-16">
        <div className="bg-white p-8 rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.08)] border-t-4 border-[#F2B705]
          transition-transform duration-300 hover:-translate-y-1 hover:shadow-[0_14px_28px_rgba(27,27,31,0.14)]">
          <h3 className="text-2xl font-bold text-[#1B1B1F] mb-4 flex items-center">
            <span className="ml-3 w-11 h-11 flex items-center justify-center rounded-full bg-[#F2B705]/15 text-[#1B1B1F]">
              <CheckIcon />
            </span>
            رؤيتنا
          </h3>
          <p className="text-gray-600">
            أن نكون المتجر الإلكتروني الرائد في المنطقة، والمكان المفضل للمتسوقين الباحثين عن الجودة والابتكار.
          </p>
        </div>
        <div className="bg-white p-8 rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.08)] border-t-4 border-[#1B1B1F]
          transition-transform duration-300 hover:-translate-y-1 hover:shadow-[0_14px_28px_rgba(27,27,31,0.14)]">
          <h3 className="text-2xl font-bold text-[#1B1B1F] mb-4 flex items-center">
            <span className="ml-3 w-11 h-11 flex items-center justify-center rounded-full bg-[#1B1B1F]/8 text-[#1B1B1F]">
              <CheckIcon />
            </span>
            رسالتنا
          </h3>
          <p className="text-gray-600">
            توفير منصة تسوق سهلة الاستخدام، وتقديم مجموعة واسعة من المنتجات التي تلبي احتياجات عملائنا، مع الالتزام بأعلى معايير الخدمة والدعم.
          </p>
        </div>
      </div>

      {/* قسم قيمنا */}
      <div className="bg-[#F6F5F2] p-8 md:p-12 rounded-2xl">
        <div className="text-center mb-10">
          <h2
            className="text-3xl font-bold text-[#1B1B1F]"
            style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
          >
            قيمنا الأساسية
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {VALUES.map((value) => (
            <div
              key={value.title}
              className="bg-white p-6 rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.06)]
                hover:shadow-[0_10px_22px_rgba(27,27,31,0.12)] transition-shadow duration-300"
            >
              <div className="flex items-center justify-end mb-4">
                <h3 className="text-xl font-bold text-[#1B1B1F]">{value.title}</h3>
                <span
                  className={`mr-3 w-10 h-10 flex items-center justify-center rounded-full ${
                    value.tone === 'yolk' ? 'bg-[#F2B705]/15 text-[#1B1B1F]' : 'bg-[#1B1B1F]/8 text-[#1B1B1F]'
                  }`}
                >
                  <CheckIcon />
                </span>
              </div>
              <p className="text-gray-600 text-right">{value.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
